



// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Components
import EmptyState from '@/shared/components/empty-state.component.vue';
import Pagination from '@/shared/components/Pagination/Pagination.component.vue';
import Search, { SearchPredefinedStyle } from '@/shared/components/search.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import ItemThumb, { ItemThumbPrefeginedStyle } from '@/shared/components/item-thumb.component.vue';
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

// Views
import ParticipantCard, {
    CardDecorationColor,
    CardNumber,
} from '@/shared/components/participant-card/participant-card.component.vue';
import ClientModal from '@/clickbuy/convocation/views/participant-list/client-modal/index.vue';

// Mixins
import SearchMixin from '@/shared/mixins/search.mixin.ts';
import WithPagination from '@/shared/mixins/withPagination.mixin.ts';

// Constants
import Assets from '@/constants/assets';
import Constants from '@/constants/constants';
import RouteNames from '@/constants/route-names';

// Filters
import pluralizeFilter from '@/shared/filters/pluralize.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';

// Models
import { Participant } from '@/manager/convocation/participant.model';

// Services
import UtilsService from '@/core/services/utils.service';


interface MixinInterface extends WithPagination, SearchMixin { }

@Component({
    name: 'cb-ParticipantList',
    components: {
        Btn,
        EmptyState,
        Icon,
        ItemThumb,
        Pagination,
        ParticipantCard,
        Search,
        Spinner,
        // Modal,
        ClientModal,
    },
    filters: {
        pluralizeFilter,
        formatDate,
    },
    computed: {
        ...mapGetters({
            getConvocation: 'getConvocation',
            participantList: 'getParticipantList',
        }),
    },
})
export default class ParticipantList extends Mixins<MixinInterface>(WithPagination, SearchMixin) {
    @Prop() private id!: string;

    private assets = Assets;
    private constants = Constants;
    private participantList!: any;
    private convocationDetailLoaded = false;
    private participantListLoaded = false;
    private initialLoading = true;
    private cleanSearch = false;
    private ordering?: string;
    private productTypeSelected: any = this.constants.switchConference;
    private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
    private searchPredefinedStyle = SearchPredefinedStyle;
    private utilsService = UtilsService;
    private iconEnum = IconEnum;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private getConvocation!: any;
    private showCustomerModal = false;
    private participantModal = new Participant();
    protected searchPhoneString = "+34"

    // @Watch("searchPhoneString")
    // private watchSearchPhoneString(newVal:any, oldVal:any){
    //     this.searchPhoneString = newVal
    // }


    private created() {
        this.initializePagination();
        this.fetchConvocation();
        window.setTimeout(() => {
            this.fetchFirstPageList();
            this.initialLoading = false;
        }, 0);
    }

    get showEmptyState() {
        return this.participantListLoaded && this.participantList.length === 0;
    }

    get showPagination() {
        return this.participantListLoaded && !this.spinner.show && this.participantList.length > 0;
    }

    get convocation() {
        return this.getConvocation(this.id);
    }

    get productName() {
        return this.convocation.product.name;
    }

    get convocationDate() {
        return this.convocation.timetables[0].date;
    }

    get convocationLocation() {
        return this.convocation.location.name;
    }

    get convocationTimeStart() {
        const splittedTime = this.convocation.timetables[0].timeStart.split(':');
        return `${splittedTime[0]}:${splittedTime[1]}h`;
    }


    public fetchList() {
        this.changeSpinnerVisibility(true);
        this.fetchParticipantList((res: any) => {
            this.onFetchSuccess(res);
            this.participantListLoaded = true;
            this.changeSpinnerVisibility(false);
        });
    }

    public searchCallback() {
        this.fetchFirstPageList();
    }

    public handleComeBack() {
        this.cleanSearch = !this.cleanSearch;
        this.searchString = '';
        this.searchPhoneString = '';
    }

    private initializePagination() {
        this.itemsPerPage = 25;
        this.limit = this.itemsPerPage;
    }

    private fetchConvocation(callback: any = () => { const doNothing = 1; }) {
        this.$store.dispatch(
            'fetchConvocation',
            {
                id: this.id,
            },
        ).then((res: any) => {
            this.convocationDetailLoaded = true;
            callback();
        });
    }

    private participantCardNumber(index: number) {
        let cardClass = CardNumber.Even;
        if (index % 2 === 1) {
            cardClass = CardNumber.Odd;
        }

        return cardClass;
    }

    private fetchParticipantList(callback: any = () => { const doNothing = 1; }) {
        const payload = {
            id: this.id,
            offset: this.offset,
            limit: this.limit,
            search: this.searchString,
            searchPhone: this.searchPhoneString,
            dateFrom: this.utilsService.today(),
            productType: this.productTypeSelected.requestName,
        };
        this.$store.dispatch('fetchParticipantList', payload)
            .then((res) => {
                callback(res);
            });
    }

    private cardClick(participant: any) {
        if (participant) {
            this.participantModal = participant;
            this.$store.dispatch('addClientToStore', participant.client);
            this.showCustomerModal = true;
        }
    }

    private goToPurchaseForm(email: string = '') {
        let participantId = this.participantModal.id || 'new';
        if (email !== '') {
            participantId = 'new';
        }
        this.$router.push({
            name: RouteNames.cbPurchaseParticipant,
            params: {
                convocationId: this.id,
                participantId,
            },
            query: {
                email,
            },
        });
    }

    private back() {
        this.$router.push({ name: RouteNames.cbConvocationList });
    }

    private newPurchase() {
        this.$router.push({
            name: RouteNames.cbPurchaseParticipant, params: {
                convocationId: this.id,
                participantId: 'new',
            }
        });
    }

    private closeClientModal(callback: any) {
        this.showCustomerModal = false;
        callback();
    }

}
